import { Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { LocalizedTextDto } from '@/api/generated';
import { getWidgetLang, pickLocalizedText } from '@/utils/localizedText';
import { FormattedText } from './FormattedText';

interface ReservationFooterProps {
  reservationNotice?: LocalizedTextDto | null;
}

/**
 * Footer component that displays reservation notice
 * Only renders if the notice is provided
 */
export function ReservationFooter({ reservationNotice }: ReservationFooterProps) {
  const { i18n } = useTranslation();
  const text = pickLocalizedText(reservationNotice, getWidgetLang(i18n.language));

  if (!text) {
    return null;
  }

  return (
    <Box
      mt={4}
      pt={3}
      pb={2}
      borderTop="1px solid"
      borderColor="divider"
      textAlign="center"
    >
      <Paper
        elevation={2}
        sx={{
          p: 2,
          mb: 2,
          backgroundColor: 'white',
          borderRadius: 2,
        }}
      >
        <Box textAlign="center">
          <FormattedText text={text} variant="body2" color="text.secondary" />
        </Box>
      </Paper>
    </Box>
  );
}
